import { defineStore } from 'pinia'
import axios from 'axios'

export const useDevStore = defineStore('dev', {
  state: () => ({
    loading: true, 
    settings: null,
  }),
  actions: {
    async loadSettings () {
        this.loading = true
        const req = await axios.get('/api/developer/settings')
        this.settings = req.data
        this.loading = false
    },
    async saveSettings (data) {
        this.loading = true
        await axios.post('/api/developer/settings', data)
        this.loading = false
    },  
  },
})
